import { useEffect, useRef } from "react";
import "./styles/BhpCategoryCard.css";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  getFileThumbnailDB,
} from "../types/constants";
import { getSessionDetails } from "../common/cookies";
import { IonAvatar, IonIcon, IonImg, IonItem } from "@ionic/react";
import {
  AdvanceCustomizationType,
  BussinessCatalogueProducts,
} from "../types/data_types";
import {
  getSeoUrl,
  truncateString,
  truncateStringHiddenContent,
} from "../common/commonFunctions";
import { star } from "ionicons/icons";

const BhpCategoryCard: React.FC<{
  imgFile?: string;
  imgFileUrl?: string;
  name?: string;
  subText?: string;
  catNum?: number;
  iconMode?: boolean;
  iconBlockMode?: boolean;
  horizontalMode?: boolean;
  listMode?: boolean;
  onClick?: () => void;
  style?: { borderRadius: string };
  verticalModeSize?: "small";
  smallIcon?: boolean;
  details?: BussinessCatalogueProducts;
  catNumCeiling?: number;
  shape?: "square";
  sizeInPx?: number;
  rating?: string | number;
  advanceCustomization?: AdvanceCustomizationType;
  marketName?: string;
}> = (props) => {
  const { token } = getSessionDetails();
  const AUTH_PARAMS = `token=${token}&Authorization=${API_SECURE_KEY}`;
  const img = !!props.imgFileUrl
    ? props.imgFileUrl
    : !!props.imgFile
    ? `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${props.imgFile}&percentage=40&${AUTH_PARAMS}&`
    : props.name?.toLowerCase() === "featured"
    ? "assets/featured-category.png"
    : "assets/default-category.png";

  const catCatEventClass = `bhp-cat-card-mode=${props?.name?.replace(
    /\s/g,
    "-"
  )}`;

  const verticalModeJsx = (
    <div
      className={`bhp-cat-card-top ${
        props.iconMode
          ? "bhp-cat-card-top-icon"
          : `bhp-cat-card-top-card ${
              props?.verticalModeSize === "small"
                ? "bhp-cat-card-top-card-small"
                : "bhp-cat-card-top-card-normal"
            }`
      } ${catCatEventClass}`}
      onClick={props?.onClick}
      id={`bhp-cat-card-${props?.name}`}
      style={{ borderRadius: props?.style?.borderRadius }}
    >
      {!props.iconMode && (
        <img
          src={img}
          alt={`${props?.name}`}
          id={`bhp-cat-card-${props?.name}-icon`}
          className={`bhp-cat-card-mode ${catCatEventClass}`}
          loading="lazy"
        />
      )}
      {props.iconMode && (
        <div
          className={`${
            props.iconBlockMode
              ? `bhp-cat-icon-block-mode ${
                  window.innerWidth > 400
                    ? "bhp-cat-icon-block-mode-size-90"
                    : "bhp-cat-icon-block-mode-size-80"
                }`
              : props.smallIcon
              ? "bhp-cat-icon-mode-small"
              : "bhp-cat-icon-mode"
          } ${catCatEventClass}`}
          style={{
            borderRadius: props?.shape === "square" ? "10px" : undefined,
            height: props?.sizeInPx ? `${props.sizeInPx}px` : undefined,
            width: props?.sizeInPx ? `${props.sizeInPx}px` : undefined,
          }}
        >
          <img
            src={img}
            alt={`${props?.name}-icon`}
            id={`bhp-cat-card-${props?.name}-icon`}
            className={`bhp-cat-card-mode ${catCatEventClass}`}
            loading="lazy"
          />
        </div>
      )}
      {!!props.rating && (
        <div
          style={{
            position: "absolute",
            bottom: "5px",
            left: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "80%",
              background: "var(--ion-color-dark)",
              color: "white",
              textAlign: "center",
              padding: "3px",
              borderRadius: "5px",
              border: "1px solid var(--ion-color-light)",
              fontSize: "0.7rem",
            }}
          >
            {props.rating} <IonIcon icon={star} /> Rated
          </div>
        </div>
      )}
      {!!props.name && (
        <div
          className={`bhp-cat-card-text ${catCatEventClass} ${
            !props.iconMode
              ? "bhp-cat-card-text-bg"
              : props.smallIcon
              ? "bhp-cat-card-text-icon-mode-small"
              : "bhp-cat-card-text-icon-mode"
          }`}
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "0.75rem",
              margin: "0",
              fontWeight: "bold",
            }}
            className={`${catCatEventClass}`}
            id={`bhp-cat-card-${props?.name}-text`}
          >
            {/* {truncateString(props.name, 15)} */}
            {truncateStringHiddenContent(
              props.name,
              props?.marketName && ` in ${props?.marketName}`,
              15
            )}
          </h2>
        </div>
      )}
    </div>
  );

  const horizontalModeJsx = (
    <div
      className={`bhp-banner-icon-mode-top ${catCatEventClass}`}
      onClick={props?.onClick}
    >
      <div
        style={{ width: "30px", height: "30px" }}
        className={`${catCatEventClass}`}
      >
        <img
          src={img}
          alt=""
          className={`bhp-cat-card-mode ${catCatEventClass}`}
          loading="lazy"
        />
      </div>
      <div className={`bhp-cat-hm-text ${catCatEventClass}`}>
        <div className={`${catCatEventClass}`}>{props.name}</div>
        {!!props.subText && (
          <div
            style={{ fontSize: "0.7rem", marginTop: "5px" }}
            className={`${catCatEventClass}`}
          >
            {props.subText}
          </div>
        )}
      </div>
    </div>
  );

  const getCatNum = (): number | string => {
    if (props?.catNumCeiling && props?.catNum > props?.catNumCeiling)
      return `${props?.catNumCeiling}+`;
    return props?.catNum;
  };

  const listModeJsx = (
    <IonItem onClick={props.onClick} lines="full">
      {props.details && props.details?.seoUrlDetails && (
        <a
          href={getSeoUrl(props.details?.seoUrlDetails)}
          className="bhp-cat-card-a-tag-no-style"
        >
          {props.details?.name}
        </a>
      )}
      <div className={`bhp-cat-list-top ${catCatEventClass}`}>
        <div className={`bhp-cat-list-name ${catCatEventClass}`}>
          <IonAvatar className={`bhp-cat-list-avatar ${catCatEventClass}`}>
            <IonImg className={`${catCatEventClass}`} src={img} />
          </IonAvatar>
          <div
            style={{
              marginLeft: "5px",
              fontSize: "small",
              fontWeight: "bold",
            }}
            className={`${catCatEventClass}`}
          >
            {props.name}
          </div>
        </div>
        <div
          style={{
            height: "1px",
            width: "20%",
            background:
              "linear-gradient(to right, var(--ion-color-light) 20%, var(--ion-color-medium) 100%)",
          }}
        ></div>

        {!!props.catNum && (
          <div
            className="bhp-cat-list-button"
            style={{
              background: `linear-gradient(to bottom right, var(--ion-color-bhp-footer), var(--ion-color-dark))`,
            }}
          >
            {getCatNum()}
          </div>
        )}
      </div>
    </IonItem>
  );

  const catNumRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (catNumRef.current) {
      catNumRef.current.style.background =
        props?.advanceCustomization?.accentColor || "red";
      catNumRef.current.style.color =
        props?.advanceCustomization?.accentColorContrast || "white";
    }
  }, [
    props?.advanceCustomization?.accentColor,
    props?.advanceCustomization?.accentColorContrast,
  ]);

  return (
    <>
      {props.details && props.details?.seoUrlDetails ? (
        <a
          href={getSeoUrl(props.details?.seoUrlDetails)}
          className="bhp-cat-card-a-tag-no-style"
        >
          <div style={{ position: "relative" }}>
            {!props.listMode && !props.horizontalMode && !!props.catNum && (
              <div className="bhp-cat-card-nitification" ref={catNumRef}>
                {getCatNum()}
              </div>
            )}
            {!props.listMode && !props.horizontalMode && verticalModeJsx}
            {!props.listMode && props.horizontalMode && horizontalModeJsx}
            {props.listMode && listModeJsx}
          </div>
        </a>
      ) : (
        <div style={{ position: "relative" }}>
          {!props.listMode && !props.horizontalMode && !!props.catNum && (
            <div className="bhp-cat-card-nitification" ref={catNumRef}>
              {getCatNum()}
            </div>
          )}
          {!props.listMode && !props.horizontalMode && verticalModeJsx}
          {!props.listMode && props.horizontalMode && horizontalModeJsx}
          {props.listMode && listModeJsx}
        </div>
      )}
    </>
  );
};

export default BhpCategoryCard;
